export const esMX = {
  ANSWER: {
    CARRIER: {
      "3PL": "3PL",
      BREAD: "PAN",
      COKE: "COCA-COLA",
      DSD: "DISTRIBUCIÓN DIRECTA EN TIENDA",
      FLOWERS: "FLORES",
      GFS: "GFS",
      LCL: "CARGA CONSOLIDADA",
      MEAT: "CARNE",
      PEPSI: "PEPSI",
    },
    DRIVER_TYPE: {
      CONTRACTOR: "Contratista",
      DELIVERY: "Entrega",
      FLEET_DRIVER: "Conductor de flota",
      GULFSTREAM: "Gulfstream",
      MAINTENANCE: "Mantenimiento",
      PERSONAL_VEHICLE: "Vehículo personal",
      SERVICE: "Servicio",
      SHUNT_DRIVER: "Operador de patio",
      SHUTTLE_DRIVER: "Conductor de transporte interno",
    },
    DUNNAGE: {
      "1_2": "1/2",
      "1_4": "1/4",
      FULL: "Completo",
    },
    ENTRY_PURPOSE: {
      BOBTAIL: "Camión sin remolque",
      CARRIER_LOADED: "Transportista cargado",
      CONTRACTOR: "Contratista",
      CONTRACTOR_VISITOR: "Contratista/Visitante",
      DELIVERY: "Entrega",
      DROP: "Descarga",
      DROP_HOOK: "Entrega y enganche",
      EMPTY: "Vacío",
      EMPTY_TRAILER: "Remolque vacío",
      FOODBANK: "Banco de alimentos",
      FUEL: "Combustible",
      LIVE_LOAD: "Carga con espera",
      LOADED: "Cargado",
      NFI_LOADED: "Cargado con NFI",
      OTHERS: "Otros",
      PARKING: "Estacionamiento",
      PICKUP_EMPTY: "Recoger remolque vacío",
      PICKUP_LOAD: "Recoger remolque con carga",
      PICK_UP: "Recolección",
      PLANT_LOADED: "Cargado en planta",
      PRIVATE: "Privado",
      REPAIR: "Reparación",
      VISITOR: "Visitante",
      WAAS_FAAS: "Almacenamiento como servicio (WAAS)/Servicio de Fulfillment (FAAS)",
      WASH: "Lavado",
    },
    ENTRY_TYPE: {
      INBOUND: "Entrada",
      INBOUND_ARRIVAL: "Entrada / \nLlegada",
      INBOUND_DROP: "Entrada / Descarga",
      MAINTENANCE: "Mantenimiento",
      OUTBOUND: "Salida",
      OUTBOUND_DEPARTURE: "Salida / \nPartida",
      OUTBOUND_PICKUP: "Salida / Recolección",
      WALMART_CARRIERS: "Transportistas de Walmart",
      YARD_STORAGE: "Estacionamiento en patio",
    },
    EQUIPMENT_LENGTH: {
      "20": "20",
      "40": "40",
      "48": "48",
      "53": "53",
    },
    EQUIPMENT_TYPE: {
      BOBTAIL: "Camión sin remolque",
      CHASSIS: "Chasis",
      CONTAINER: "Contenedor",
      TRAILER: "Remolque",
      VAN: "Furgoneta",
    },
    FUEL_LEVEL: {
      "1_2": "1/2",
      "1_4": "1/4",
      "1_8": "1/8",
      "3_4": "3/4",
      "3_8": "3/8",
      "5_8": "5/8",
      "7_8": "7/8",
      EMPTY: "Vacío",
      FULL: "Lleno",
    },
    GENERIC: {
      NO: "NO",
      YES: "SÍ",
    },
    LOADED_STATUS: {
      EMPTY: "Vacío",
      LOADED: "Cargado",
    },
    LOAD_DETAILS: {
      CONVERTER_1X: "CONVERTER_1X",
      CONVERTER_2X: "CONVERTER_2X",
      DRY: "CARGA SECA",
      FROZEN: "CARGA CONGELADA",
      HEAT: "CALOR",
      "MULTI TEMP": "MULTITEMPERATURA",
      REEFER: "REFRIGERADO",
    },
    LOAD_TYPE: {
      BOBTAIL: "Camión sin remolque",
      EMPTY: "Vacío",
      LOADED: "Cargado",
      OTHERS: "Otros",
    },
    REEFER: {
      OFF: "Apagado",
      ON: "Encendido",
    },
    TRAILER_TYPE: {
      DRY: "Caja seca",
      REEFER: "Remolque refrigerado",
    },
    VISIT_TYPE: {
      DROP_AND_GO: "Entrega sin espera",
      DROP_AND_WAIT: "Entrega con espera",
      DROP_EMPTY: "Dejar remolque vacío",
      PICKUP_EMPTY: "Recoger remolque vacío",
    },
  },
  APP: {
    DEVELOPED_BY_EAIGLE: "Desarrollado por EAIGLE",
    INVALID_FACILITY: "¡NO SE ENCONTRÓ LA INSTALACIÓN!",
    PAGE_NOT_FOUND: "Página no encontrada. Parámetros no válidos",
    PLEASE_ROTATE:
      "Coloque su dispositivo en orientación vertical para utilizar esta aplicación.",
    POWERED_BY_EAIGLE: "Desarrollado por <LOGO/> eaigle.com",
  },
  AVAC: {
    ADD_COMMENT_HEADER: "Agregar comentario (obligatorio)",
    AREA: {
      ISO: "ISO",
      TANK_WASH: "Limpieza de tanque",
    },
    COMMENT_HERE: "Agregue su comentario aquí...",
    COMMENT_SUBMITTED: "Comentario enviado",
    DETAILS: {
      ATTACHMENTS: {
        TITLE: "Adjuntos de la cita",
        DOWNLOAD: "Descargar",
        SHOW_SYSTEM: "Mostrar adjuntos del sistema",
        PREVIEW_UNAVAILABLE: "Vista previa no disponible. Use la descarga en su lugar.",
        UPLOADER: {
          DRIVER: "Conductor",
          AGENT: "Agente",
          SYSTEM: "Sistema",
        },
        KIND: {
          SEAL: "Sello",
          BOL: "BOL",
          QRCODE: "Código QR",
        },
      },
      ACTUAL_TEMPERATURE: "Temperatura actual",
      ADDITIONAL_COMMENTS: "Comentarios adicionales",
      ALLOCATED_PAD: "PAD asignado",
      APPOINTMENT_INFORMATION: "Información de la cita de carga/descarga",
      APPOINTMENT_NUMBER: "Número de la cita",
      APPOINTMENT_TIME: "Hora de la cita",
      APPOINTMENT_TYPE: "Tipo de cita",
      AVAC_EVENT: "AVAC Evento",
      BOL_NUMBER: "Número de conocimiento de embarque",
      BOOKING_NUMBER: "Número de reserva",
      BRE_STATUS: "Estado BRE",
      BROKER: "Agente",
      CARRIER: "Transportista",
      CARRIER_NAME: "Nombre del transportista",
      CHASSIS_NUMBER: "Número de chasis",
      CHILD_SCAC: "SCAC secundario",
      COMMENT: "Comentario",
      CVIP_DATE: "Fecha de inspección CVIP",
      CV_DETAILS: "Información de CV",
      CV_EVENT_ID: "ID de evento de CV",
      DELIVERY_NOTE: "Nota de entrega",
      DESCRIPTION: "Descripción",
      DRIVER_ENGAGEMENT_TIME: "Tiempo de servicio del conductor(seg)",
      DRIVER_INFORMATION: "Información del conductor",
      DRIVER_NAME: "Nombre del conductor",
      DUNNAGE: "Material de estiba",
      ENTRY_SUBTYPE: "Subtipo de ingreso",
      ENTRY_TYPE: "Tipo de ingreso",
      EQUIPMENT_LENGTH: "Longitud del equipo",
      EQUIPMENT_LOADED_STATUS: "Estado de carga del equipo",
      EQUIPMENT_TYPE: "Tipo de equipo",
      EQUIPMENT_TYPE_ID: "ID del tipo de equipo",
      EVENT_ID: "ID del evento",
      EVENT_INFORMATION: "Información del evento",
      EVENT_TIME: "Hora del evento",
      EVENT_TYPE: "Tipo de evento",
      FAILURE_REASON: "Motivo de la falla",
      FIRST_NAME: "Nombre",
      FUEL_LEVEL: "Nivel de combustible",
      GATE_ENGAGEMENT_TIME: "Tiempo de gestión en acceso (seg)",
      ID: "ID",
      IMAGES: "Imágenes",
      LANE_ID: "ID de carril",
      LANE_NAME: "Nombre del carril",
      LAST_NAME: "Apellido",
      LIVE_DROP: "Entrega con espera",
      LOAD_ID: "ID de carga",
      LTL: "CARGA CONSOLIDADA",
      MC_NUMBER: "Número de Autotransportista",
      OPERATOR_COMMENTS: "Comentario del operador",
      ORDER_NUMBER: "Número de orden",
      PARENT_SCAC: "SCAC principal",
      PHONE_NUMBER: "Número de teléfono",
      PLATE_NUMBER: "Número de placa del vehículo",
      PO: "OC",
      PO_LOAD_DETAILS: "Información de la OC / Carga",
      PO_NUMBER: "Número de OC",
      RAIL_CARS: "Carros de ferrocarril",
      REFERENCE_NUMBER: "Número de referencia",
      SCAC: "SCAC",
      SEAL_NUMBER: "Número de sello",
      SET_TEMPERATURE: "Temperatura programada",
      SPOT_NUMBER: "Número de espacio",
      START_TIME: "Hora de inicio",
      STATUS: "Estado",
      TEMPERATURE: "Temperatura",
      TIMESTAMP: "Marca de tiempo",
      TRACTOR_ID: "ID del tractocamión",
      TRACTOR_NUMBER: "Número del tractocamión",
      TRAILER: "Remolque",
      TRAILER_NUMBER: "Número de remolque",
      TRAILER_TYPE: "Tipo de remolque",
      TRUCK_INFORMATION: "Datos del camión",
      TRUCK_NUMBER: "Número del camión",
      UNIT: "Unidad",
      UNIT_ID: "ID de unidad",
      UNIT_NUMBER: "Número de unidad",
      UNIT_TYPE: "Tipo de unidad",
      USDOT_NUMBER: "Número USDOT",
      VEHICLE_MEDIA: "Multimedia del vehículo",
      VIDEOS: "Videos",
      WAC: "Código de área del almacén",
      ZONE: "Zona",
    },
    DRIVER_ASSIST: "Asistencia al conductor",
    DRIVER_CREATED: "¡Conductor creado correctamente!",
    DRIVER_PIN: "PIN del conductor:",
    DRIVER_QR_CODE: "Código QR del conductor",
    DRIVER_UPDATED: "¡Conductor actualizado correctamente!",
    ERROR: {
      ACCESS_DENIED: "Acceso denegado",
      ACCESS_DENIED_DETAILS: "No tiene acceso a este módulo.",
      AUTH_ERROR: "Error de autenticación: {{ERROR}}",
      CONTACT_ADMIN: "Comuníquese con su administrador para obtener permiso.",
      ERROR_CREATING_DRIVER: "Se produjo un error al crear el conductor",
      ERROR_UPDATING_DRIVER: "Se produjo un error al actualizar el conductor",
      FAILED_TO_CREATE_DRIVER: "Error al crear el conductor",
      FAILED_TO_FETCH_FACILITIES: "Error al cargar las instalaciones",
      FAILED_TO_UPDATE_DRIVER: "Error al actualizar el conductor",
      LOADING_EVENT_DETAILS_AVAC:
        "Error al cargar la información del evento. Redirigiendo a AVAC...",
      LOADING_EVENT_DETAILS_GATE_LOG:
        "Error al cargar la información del evento. Redirigiendo a Registro de acceso...",
      MISSING_EMAIL_AND_PHONE_NUMBER:
        "Ingrese un correo electrónico o un número de teléfono",
      NO_FACILITY_SELECTED: "Debe seleccionar una instalación",
      WEBSOCKET_ERROR: "Error de WebSocket: {{ERROR}}",
    },
    FACILITY: "Instalación",
    FAILED_EVENTS: "Eventos con error",
    HISTORICAL_EVENTS: "Eventos anteriores (último día)",
    IMAGE_MODAL_INSTRUCTIONS:
      "Desplácese para acercar â€¢ Arrastre para desplazarse cuando esté ampliado",
    NEW_DRIVER: {
      PIN_SENT:
        "El PIN se envió al correo electrónico y al número de teléfono del conductor.",
      QR_CODE_AND_PIN_SENT:
        "El código QR y el PIN se enviaron al correo electrónico y al número de teléfono del conductor.",
      QR_CODE_SENT:
        "El código QR se envió al correo electrónico y al número de teléfono del conductor.",
    },
    NO_APPROVED_EVENTS:
      "No se encontraron eventos aprobados para el rango de fechas seleccionado",
    NO_EVENTS: "No existen eventos disponibles",
    NO_FAILED_EVENTS: "No se detectaron eventos con error en las últimas 24 horas",
    NO_INVENTORY: "Inventario vacío.",
    NO_LANES: "Sin carriles habilitados.",
    NO_MATCHES: "No se encontraron coincidencias",
    NO_NON_FAILURE_EVENTS: "No se registraron eventos exitosos en las últimas 24 horas",
    NO_VEHICLE_MEDIA: "Sin archivos multimedia del vehículo disponibles",
    PRODUCT_NAME: "AVAC™",
    READ_AND_AGREE: "Lea y acepte el <BUTTON>Formulario de exención</BUTTON>",
    SELECT_LANE: "Seleccione carril",
    SUBMITTING: "Enviando...",
    SUGGESTION: {
      EMAIL_OR_PHONE_NUMBER: "Complete el campo de correo electrónico o de teléfono",
    },
    TOAST: {
      APPROVE_EVENT_FAILED: "Error al aprobar el evento. Inténtelo nuevamente.",
      EVENT_APPROVED: '¡Evento aprobado con éxito! Haga clic en el botón "Abrir puerta".',
      EVENT_REJECTED: "Evento rechazado.",
      GATE_OPENED: "¡La puerta se abrió correctamente!",
      OPEN_GATE_FAILED:
        "Error al abrir la puerta. Inténtelo nuevamente o comuníquese con soporte técnico.",
      REJECT_EVENT_FAILED: "Error al rechazar el evento. Inténtelo nuevamente.",
    },
    VALIDATING_ACCESS: "Validando su acceso...",
    VALIDATION: {
      INVALID_EMAIL: "Ingrese un correo electrónico válido",
      INVALID_NAME: "Debe contener solo letras y espacios",
      INVALID_PHONE_NUMBER: "Ingrese un número de teléfono válido de 10 dígitos",
    },
  },
  BRE: {
    FAILED_TO_OPEN_GATE: "Error al abrir la puerta",
    GATE_OPEN_FAILED: "La apertura de la puerta falló",
    INVALID_APPOINTMENT: "Cita no válida",
    DRIVER_REGISTRATION_EXPIRED:
      "El registro del conductor no es válido. Comuníquese con el operador de la puerta.",
    INVALID_QRCODE_FORMAT: "Formato no válido de código QR",
    KRAFT: {
      APPOINTMENT_USAGE_EXCEEDED: "La cita superó el límite de uso",
      BOL_CALL_FAILED: "Error en la consulta de conocimiento de embarque",
      BOL_CALL_FAILED_NO_LANE_EVENT:
        "BOL La consulta falló o no existe un CVLaneEvent en curso",
      BOL_PO_MISSING: "Falta el número de Conocimiento de embarque / OC en la cita",
      BOL_PO_MISSING_NO_LANE_EVENT:
        "Falta el número de Conocimiento de embarque / OC en la cita y no existe un CVLaneEvent en curso",
      CVLANE_EVENT_NOT_FOUND: "No existe el CVLaneEvent",
      EVENT_OUTSIDE_OPERATION_HOURS: "Evento fuera del horario de operación",
      FAILED_OBTAIN_BOL_INFO:
        "No se pudo obtener la información del Conocimiento de embarque",
      FUEL_LEVEL_BELOW_THRESHOLD:
        "El nivel de combustible es inferior a 0,75 y no existe un CVLaneEvent en curso",
      FUEL_LEVEL_BELOW_THRESHOLD_NO_LANE_EVENT:
        "El nivel de combustible es inferior a 0,75 y no existe un CVLaneEvent en curso",
      INTERNAL_FAILURE: "Error interno",
      INVALID_APPOINTMENT_ENTRY_SUBTYPE: "Subtipo de ingreso de cita no válido",
      INVALID_APPOINTMENT_ENTRY_TYPE: "Tipo de ingreso de cita no válido",
      INVALID_APPOINTMENT_QR_CODE: "Código QR de cita no válido",
      INVALID_ENTRY_SUBTYPE: "Subtipo de ingreso no válido",
      INVALID_ENTRY_SUBTYPE_IN_APPOINTMENT: "Subtipo de ingreso no válido en la cita",
      INVALID_ENTRY_SUBTYPE_NO_LANE_EVENT:
        "Subtipo de ingreso no válido en la cita y no existe un CVLaneEvent en curso",
      INVALID_INBOUND_BOBTAIL_PLATE_NUMBER:
        "Número de placa de camión sin remolque entrante no válida",
      INVALID_OUTBOUND_EMPTY_APPOINTMENT_USAGE:
        "Uso no válido de cita de salida con remolque vacío",
      INVALID_QRCODE_SOURCE: "Fuente no válida de código QR",
      MAX_APPOINTMENT_LIMIT_REACHED: "Se alcanzó el límite máximo de uso de citas",
      NO_CV_LANE_EVENT_FOUND_OR_UNSUPPORTED_APPOINTMENT_MISMATCH_USAGE:
        "No se encontró un CVLaneEvent o existe un uso de cita no compatible por discrepancia",
      NO_INPROGRESS_LANE_EVENT_FOUND: "No existe un LaneEvent en curso",
      NO_INPROGRESS_LANE_EVENT_FOUND_OR_TRAILER_NUMBER_IS_PRESENT_IN_THE_RECORD:
        "No existe un LaneEvent en curso o el número de remolque ya figura en el registro",
      NO_USER_INFO_RECEIVED: "No se recibió información del usuario",
      NO_VEHICLE_DETECTED: "Vehículo no detectado o tipo de vehículo no válido",
      NO_VEHICLE_DETECTED_BOBTAIL: "Vehículo no detectado o no es camión sin remolque",
      PLEASE_PROCEED_TO_DOCK_OFFICE: " Por favor, diríjase a la oficina de andén",
      SEAL_NUMBER_MISMATCH: "El número de sello no coincide",
      SEAL_NUMBER_MISSING: "Falta el número de sello en el registro de salida con carga",
      TEMPERATURE_EXCEEDS_LIMIT: "La temperatura excede el límite",
      TEMPERATURE_INFO_MISSING:
        "Falta la información de temperatura y, debido a la temporada actual, no se puede omitir la verificación de temperatura",
      TEMPERATURE_INFO_MISSING_NO_LANE_EVENT:
        "Falta la información de temperatura y, debido a la temporada actual, no se puede omitir la verificación de temperatura. No existe un CVLaneEvent en curso",
      TEMPERATURE_INFO_NOT_INCLUDED:
        "No se incluyó la información de temperatura en la cita",
      TEMPERATURE_INFO_NOT_INCLUDED_NO_LANE_EVENT:
        "No se incluyó la información de temperatura en la cita y no existe un CVLaneEvent en curso",
      TRAILER_NUMBER_DOES_NOT_MATCH: "El número de remolque no coincide.",
      TRAILER_NUMBER_DOES_NOT_MATCH_WITH_RECORD:
        "El número de remolque no coincide con el registro",
      TRAILER_NUMBER_IS_NOT_AVAILABLE: "El número de remolque no está disponible",
      TRAILER_NUMBER_MISSING: "Falta el número de remolque o no coincide con el registro",
      TRAILER_NUMBER_NOT_PRESENT: "La cita no contiene el número de remolque",
      TRAILER_NUMBER_SHOULD_NOT_EXIST:
        "El número de remolque no debería existir en el registro",
      UNABLE_TO_VALIDATE_TEMPERATURE: "No es posible validar la temperatura",
      UNSUPPORTED_APPOINTMENT_TYPE: "l Tipo de cita incompatible por discrepancia",
    },
    LACTALIS: {
      APPOINTMENT_DOES_NOT_EXIST: "La cita no existe",
      OFF_HOURS_OUTBOUND_TRAILER:
        "Para las salidas con remolque fuera de horario se deberá utilizar el intercomunicador",
      OUTBOUND_TRAFFIC_WORKING_HOURS:
        " En horario laboral, el tráfico de salida deberá utilizar el intercomunicador",
      YMS_CHECKIN_FAILED:
        "YMS Error en el registro de entrada. Por favor, comuníquese con el operador de la puerta",
    },
    LOBLAW: {
      ENTRY_APPROVED: "Ingreso aprobado. Diríjase al área asignada {{MESSAGE}}",
      INVALID_INFORMATION: "Información no válida",
      PROCEED_TO_DISPATCH:
        "{{MESSAGE}} Por favor, diríjase a la oficina de despacho para más detalles",
      SEE_YOU_NEXT_TIME: "{{MESSAGE}} Hasta la próxima",
    },
    PORTCITY: {
      AFTER_HOURS_ENTRY:
        "En caso de ingreso fuera del horario de operación, utilice el teclado numérico en el carril central. Su oficina de despacho le proporcionará el código",
      BOOKING_NUMBER_PROVIDED_NOT_VALID: "El número de reserva ingresado no es válido",
      INVALID_EAIGLE_APPOINTMENT_RECORD: "Registro de cita Eaigle no válido",
      INVALID_PROFILE_OR_EXPIRED_CREDENTIAL:
        "El perfil no es válido o la credencial ha expirado",
      IT_IS_NOT_AN_OUTBOUND_BOBTAIL: "No corresponde a una salida de camión sin remolque",
      IT_IS_NOT_A_BOBTAIL: "No es un camión sin remolque",
      LOADID_PROVIDED_IS_NOT_VALID: "El ID de carga proporcionado no es válido",
      NO_BOOKING_NUMBER_PROVIDED: "No se ingresó un número de reserva",
      NO_INPROGRESS_CV_LANE_EVENT_FOUND: "No existe un CV LaneEvent en curso",
      NO_LOADID_PROVIDED: "No se ingresó el ID de carga",
      PICK_UP_BOL: "{{MESSAGE}} Recoja el Conocimiento de embarque en la puerta 25",
      PLEASE_CONTACT_SECURITY_TO_OPEN_GATE:
        " Por favor, comuníquese con Seguridad para abrir la puerta",
      UNSUPPORTED_APPOINTMENT_TYPE: "Tipo de cita no admitido",
      UNSUPPORTED_OPERATION_TYPE: "Tipo de operación no admitida",
    },
    TRIMAC: {
      NOT_A_VALID_REQUEST: "Solicitud no válida",
    },
  },
  CARRIER: {
    SCAC_AND_NAME: "{{SCAC}} ({{NAME}})",
    NAME_AND_SCAC: "{{NAME}} ({{SCAC}})",
  },
  CATEGORY: {
    ACTUAL_TEMPERATURE: "Temperatura actual",
    ACTUAL_TEMPERATURE_F: "Temperatura actual °F",
    COMPANY: "Información de la empresa",
    EQUIPMENT_DETAILS: "Información del equipo",
    LOAD_DETAILS: "Información de la carga",
    PERSONAL: "Información personal",
    PURPOSE_DETAILS: "Información del propósito",
    SAFETY: "Seguridad",
    SET_TEMPERATURE: "Temperatura programada",
    SET_TEMPERATURE_F: "Temperatura programada °F",
    SHIPPING_DETAILS: "Información del envío",
    SHIPPING_DETAILS_WITHOUT_VALIDATION: "Información del envío sin validación",
    SHIPPING_DETAILS_WITH_VALIDATION: "Información del envío con validación",
    VEHICLE_EQUIPMENT_DETAILS: "Información del vehículo/equipo",
    VISIT_PURPOSE: "Propósito de la visita",
  },
  COMMAND: {
    ADD_NEW_DRIVER: "Agregar nuevo conductor",
    APPROVE: "Aprobar",
    BACK: "Atrás",
    BACK_TO_EVENTS: "Volver a eventos",
    CHECK_IN: "Registro de entrada",
    CHECK_OUT: "Registro de salida",
    CLEAR: "Limpiar",
    CLICK_TO_EDIT: "Haga clic para editar",
    CLOSE: "Cerrar",
    CLOSE_IMAGE_MODAL: "Cerrar ventana de imagen",
    DELETE: "Eliminar",
    EDIT: "Editar",
    LOGOUT: "Cerrar sesión",
    NEXT: "Siguiente",
    OPEN_GATE: "Abrir puerta",
    REJECT: "Rechazar",
    RETURN: "Regresar",
    SELECT_END: "Seleccionar Fin",
    SELECT_START: "Seleccionar Inicio",
    SSO_LOGIN: "Iniciar sesión con Azure AD",
    START_NEW_REGISTRATION: "Iniciar nuevo registro",
    SUBMIT: "Enviar",
    TODAY: "Hoy",
    UPDATE: "Actualizar",
  },
  DAY: {
    "0": "Dom",
    "1": "Lun",
    "2": "Mar",
    "3": "Mié",
    "4": "Jue",
    "5": "Vie",
    "6": "Sáb",
  },
  ERROR: {
    VIDEO_NOT_SUPPORTED: "Su navegador no admite la reproducción de video",
  },
  ERROR_MODAL: {
    INVALID_X: "No válido {{TITLE}}",
  },
  EVENT_STATUS: {
    APPROVED: "Aprobado",
    FAILURE: "falla",
    INPROGRESS: "en curso",
    REJECTED: "rechazado",
    SUCCESS: "correcto",
  },
  FAILURE_PAGE: {
    BODY: "Oprima el botón del intercomunicador en el quiosco",
    FAILURE: "Falla",
    HEADER: "¡Información no verificada!",
    INTERCOM: "Intercomunicador",
  },
  FILTER: {
    CARD: {
      EVENT_TYPE: "Tipo de evento",
      STATUS: "Estado",
      TIME: "Hora",
      TRAILER_LOGO: "Logotipo del remolque",
    },
    EVENT_TYPE: {
      JB_HUNT: "JB Hunt",
    },
    LOGO: {
      AB: "AB",
      CD: "CD",
      DH: "DH",
      EF: "EF",
    },
    STATUS: {
      CLEAN: "Limpio",
      DIRTY: "Sucio",
      EMPTY: "Vacío",
      INBOUND: "Entrada",
      LOADED: "Cargado",
      OUTBOUND: "Salida",
    },
    TIME: {
      LAST_24_HOURS: "Últimas 24 horas",
      LAST_MONTH: "Último mes",
      LAST_WEEK: "Última semana",
      LAST_YEAR: "Último Año",
      TODAY: "Hoy",
    },
  },
  FORM_INPUT: {
    COMMAND: {
      ENTER_SCAC: "Haga clic para ingresar manualmente el SCAC",
      SELECT_SCAC: "Haga clic para seleccionar entre los códigos SCAC disponibles",
      SHOW_LESS: "Ver menos",
      SHOW_MORE: "Ver más",
    },
    FIELD_IS_REQUIRED: "Debe completar este campo",
    NO_MATCHES: "No se encontraron coincidencias",
    REQUIRED_LABEL: "{{TEXT}}*",
    SELECT: "Buscar o seleccionar...",
    SELECT_CARRIER: "Buscar o seleccionar transportista...",
    SELECT_DATE: "Seleccionar fecha",
    SELECT_OPTIONS: "Seleccionar opciones...",
    TRUNCATED: "{{TEXT}}...",
  },
  FORM_PAGE: {
    COMMAND: {
      NEXT: "Siguiente",
      SUBMIT: "Enviar",
    },
    ERROR: {
      UNABLE_TO_SUBMIT:
        "No es posible enviar el formulario. Inténtelo nuevamente más tarde.",
    },
    VALIDATING: "Validando...",
    UPLOADING: "Subiendo {{percent}}%",
    PROCESSING: "Procesando...",
  },
  HINT: {
    EDIT_SEAL_NUMBER: "* Modifique el número de sello registrado si es necesario.",
    LOAD_ID_8_DIGITS: "Su ID de carga es un número de 8 dígitos que comienza con 4",
    SCAC_NOT_LISTED_CPU9: "Si su SCAC no aparece en la lista, por favor ingrese CPU9.",
  },
  IDCAPTURE: {
    CAMERA_ERROR: {
      BODY: "No pudimos acceder a su cámara. Compruebe los permisos y vuelva a intentarlo.",
      HEADER: "Error de acceso a la cámara",
    },
    COMMAND: {
      CAPTURE: "Capturar credencial",
      CAPTURING: "Capturando...",
      CHANGE_TYPE: "Cambiar el tipo de credencial",
      DONE: "Listo",
      RETAKE_PHOTOS: "Volver a tomar fotos",
      SUBMIT: "Enviar",
      SWITCH_CAMERA: "Cambiar cámara",
      TRY_AGAIN: "Inténtelo nuevamente",
      TRY_BACK: "Usar cámara trasera",
      TRY_FRONT: "Usar cámara frontal",
    },
    EMPLOYEE_ID_BACK: "Credencial del empleado (reverso)",
    EMPLOYEE_ID_BACK_ALT: "Reverso de la credencial del empleado",
    EMPLOYEE_ID_FRONT: "Credencial del empleado (frente)",
    EMPLOYEE_ID_FRONT_ALT: "Frente de la credencial del empleado",
    ERROR: {
      EXPIRED: "La credencial está vencida. Indique una credencial válida.",
      GENERIC: "Algo salió mal",
      NO_CAMERA:
        "Cámara no accesible. Por favor, conecte su cámara o intente con un navegador diferente.",
      NO_SWITCH:
        "No es posible cambiar a otra cámara porque existe solo un dispositivo de video accesible.",
      PERMISSION_DENIED:
        "Permiso denegado. Actualice la página y permita el acceso a la cámara.",
      UNREADABLE: "No se pudo leer la información de la credencial.",
      UNSUPPORTED: "Canvas no es compatible.",
      UPLOAD_FAILED: "Error al cargar las imágenes de la credencial del empleado",
      UPLOAD_FAILED_TRY_AGAIN:
        "Error al cargar las imágenes de la credencial del empleado. Inténtelo nuevamente.",
      VERIFY_FAILED_TRY_AGAIN:
        "Error al verificar la identificación. Inténtelo nuevamente.",
    },
    ID_INFORMATION: "Información de la credencial",
    ID_NOT_VERIFIED_MESSAGE:
      "No pudimos verificar completamente su identificación. Por favor, revise los detalles a continuación.",
    ID_NOT_VERIFIED_STATUS: "Problemas de verificación de identificación",
    ID_VERIFIED_MESSAGE: "Su identificación se verificó con éxito.",
    ID_VERIFIED_STATUS: "Verificación de identificación exitosa",
    INSTRUCTIONS: {
      DIGITAL_MX_CDL:
        "Las licencias federales digitales de México solo se aceptan en formato impreso. Fotografíe únicamente la mitad superior de la hoja.",
      DRIVERS_LICENSE:
        "Coloque su licencia de conducir dentro del marco y asegúrese de tener buena iluminación",
      EMPLOYEE_ID_BACK:
        "Ahora coloque el REVERSO de su credencial de empleado dentro del marco.",
      EMPLOYEE_ID_FRONT:
        "Coloque el FRENTE de su credencial de empleado dentro del marco.",
    },
    PROCESSING: "Procesando...",
    SELECT_TYPE: "Seleccione tipo de identificación",
    TYPE: {
      DRIVERS_LICENSE: "Licencia del conductor",
      EMPLOYEE_ID: "Credencial del empleado",
    },
  },
  IMAGE_PREVIEW: {
    CAPTURED_ID: "Credencial capturada",
    COMMAND: {
      RETAKE: "Volver a tomar",
      SUBMIT: "Enviar",
    },
    PLEASE_WAIT: "Espere mientras verificamos su información",
    PROCESSING_ID: "Procesando su credencial...",
    SUBMITTING: "Enviando...",
    TIP: "Asegúrese de que la imagen sea clara y legible.",
  },
  KIOSK: {
    COMMAND: {
      ENTER: "Introducir",
      REGISTER_NOW: "Regístrese ahora",
    },
    ERROR: {
      CONNECTION_CLOSED: "Sesión finalizada",
      CONNECTION_ERROR: "Error de conexión",
      ENTRY_TYPE_INVALID: 'El tipo de ingreso "{{TYPE}}" no es válido',
      ENTRY_TYPE_MISSING: "Falta el tipo de ingreso",
      FAILED_TO_CONNECT: "No se pudo establecer la conexión",
      INFORMATION_NOT_VERIFIED_USE_INTERCOM:
        "¡Información no verificada! Utilice el intercomunicador",
      INTERACTION_TYPE_INVALID: 'El tipo de interacción "{{TYPE}}" no es válido',
      INTERACTION_TYPE_MISSING: "Falta el tipo de interacción",
      INTERMITTENT_CONNECTION:
        "Error de conexión intermitente. Si el problema persiste, por favor contacte al soporte de EAIGLE @ 1 888 771 1584",
      INTERMITTENT_CONNECTION_N: "Error de conexión intermitente {{N}}",
      MISSING_REQUIRED_INFO: "Falta información obligatoria",
      PROCESSING_ERROR: "Error al procesar su solicitud. Utilice el intercomunicador",
      VALIDATION_FAILED: "El proceso de validación falló",
      VALIDATION_TIMEOUT: "Se agotó el tiempo de validación",
    },
    FOOTER: {
      NOT_REGISTERED: "¿No está registrado?",
    },
    GATE_OPEN: "Puerta abierta",
    INFORMATION_VERIFIED: "¡Información verificada!",
    INVALID_URL_PARAMETERS: "Parámetros de URL no válidos",
    KEY: {
      BACKSPACE: "Retroceso",
      CLEAR: "Borrar",
      CLOSE: "Cerrar",
    },
    KEY_PAD_INSTRUCTIONS: "Ingrese la contraseña de un solo uso",
    PLEASE_ROTATE_LANDSCAPE: " Por favor, gire su dispositivo a modo horizontal",
    PLEASE_WAIT_X: "Espere un momento. {{TEXT}}",
    PRE_REGISTERED: "¿Cuenta con pre-registro?",
    PROCEED_TO_EXIT: "Por favor, diríjase a la salida",
    PROCEED_TO_ZONE: "Diríjase a la zona asignada",
    REDIRECTING: "Redirigiendo...",
    SCAN_QR_CODE:
      "Coloque su <br/> código QR pre-registrado frente al quiosco para <br/> escanearlo",
    SECONDS_REMAINING: "{{N}} segundos restantes",
    TROUBLE_SCANNING_QR_CODE:
      "¿Problemas para escanear su código QR? - Presione aquí para ingresar manualmente el código de cita",
    VALIDATION: {
      PERSON_NAME: "Solo letras y espacios",
      PHONE_NUMBER: "p. ej., 1234567890",
    },
    VERIFYING_INFORMATION: "Verificando información...",
    VIDEO_NOT_AVAILABLE: "Video en vivo no disponible",
    WAIT_VERIFY_INFO: "Espere un momento mientras validamos su información",
    WAIT_VERIFY_QR: "Espere un momento mientras se verifica el código QR",
  },
  LABEL: {
    APPROVED: "Aprobado",
    AREA: "Área",
    CARRIER: "Transportista",
    CHECK_ICON: "Ícono de verificación",
    CHECK_IN_TIME: "Hora de registro",
    CHECK_OUT_TIME: "Hora de registro de salida",
    DETENTION_TIME: "Tiempo de detención",
    INDICATORS: "Indicadores",
    DETENTION_TIME_HOURS: "Tiempo de detención (horas)",
    DRIVERS: "Conductores",
    DURATION: "Duración",
    ERROR_ICON: "Ícono de error",
    FIRST_NAME_LAST_NAME: "{{FIRST}} {{LAST}}",
    FROM_DATE_TIME_TZ: "Desde: {{DATE_TIME_TZ}}",
    GATE_LOG: "Registro de acceso",
    GATE_OPEN: "Acceso abierto",
    LOCATION: "Ubicación",
    NOT_APPLICABLE: "N/D",
    OPENING: "Abriendo...",
    REGISTRATION: "Registro",
    ROW: "Fila",
    SECTION_N: "{{SECTION}} {{N}}",
    SPOT: "Lugar",
    STEP_N: "Paso {{N}}",
    TANKER: "Camión cisterna",
    TIME: "Hora",
    TIME_STAMP: "Marca de tiempo",
    TOTAL_RECORDS_N: "Total de registros: {{N}}",
    TO_DATE_TIME_TZ: "A las: {{DATE_TIME_TZ}}",
    UNIT_1: "Unidad 1",
    UNIT_HISTORY: "Historial de unidad",
    UNIT_ID: "ID de unidad",
    UNIT_TYPE: "Tipo de unidad",
    YARD_CHECK: "Inspección de patio",
    YARD_INVENTORY: "Inventario de patio",
    ZOOMABLE_TYPE: "Ampliable {{TYPE}}",
  },
  MONTH: {
    "1": "Enero",
    "2": "Febrero",
    "3": "Marzo",
    "4": "Abril",
    "5": "Mayo",
    "6": "Junio",
    "7": "Julio",
    "8": "Agosto",
    "9": "Septiembre",
    "10": "Octubre",
    "11": "Noviembre",
    "12": "Diciembre",
  },
  NAVBAR: {
    COMMAND: {
      PREVIOUS: "Anterior",
    },
    DRIVER_REGISTRATION: "Registro de conductores",
    LOGO: "Logotipo",
  },
  PASSCODE_PAGE: {
    COMMAND: {
      VERIFY: "Verificar",
    },
    ENTER_PASSCODE: "Ingrese su código de acceso",
    ERROR: {
      INVALID_PASSCODE: "Código de acceso no válido",
    },
  },
  PLACEHOLDER: {
    ACTUAL_TEMPERATURE_F: "Temperatura actual (°F)",
    BOL_OR_PO_NUMBERS: "Conocimiento(s) de embarque(s) / OC(s)",
    BOOKING_NUMBER: "Número de reserva",
    CARRIER: "Transportista",
    CARRIER_NAME_PARENT_SCAC: "Nombre del transportista (código SCAC principal)",
    CARRIER_SCAC: "Ingrese SCAC del transportista",
    COMPANY_NAME: "Información de la empresa",
    CURRENT_TEMPERATURE_F: "Temperatura actual (°F)",
    CVIP_DATE: "Fecha de inspección CVIP",
    DRIVER_FIRST_NAME: "Nombre del conductor",
    DRIVER_LAST_NAME: "Apellido del conductor",
    DRIVER_NAME: "Nombre del conductor",
    DRIVER_TYPE: "Tipo de conductor",
    DUNNAGE: "Material de estiba",
    EMAIL: "Correo electrónico",
    EMAIL_ADDRESS: "Dirección de correo electrónico",
    ENTRY_TYPE_REASON: "Tipo de ingreso (motivo de la visita)",
    EQUIPMENT_LENGTH: "Longitud del equipo",
    EQUIPMENT_LOADED_STATUS: "Estado de carga del equipo",
    EQUIPMENT_TYPE: "Tipo de equipo",
    FIRST_NAME: "Nombre",
    FUEL_LEVEL: "Nivel de combustible",
    ID_VALIDATION: "Validación de ID",
    I_AGREE: "Acepto",
    LAST_NAME: "Apellido",
    LOAD_ID: "ID de carga",
    LOAD_ID_NUMBER: "Número de ID de carga",
    OUTBOUND_BOL: "Conocimiento de embarque de salida",
    PHONE_NUMBER: "Número de teléfono",
    PO_NUMBER: "Número de OC",
    PO_NUMBER_OR_LOAD_ID: "Número de OC, ASN o ID de carga/referencia",
    PPE_DOCK_SAFETY: "EPP y seguridad en el andén",
    PPE_DOCK_SAFETY_ASSISTANCE:
      "Si necesita asistencia con la seguridad en el muelle o tiene inquietudes relacionadas con el equipo de protección personal (EPP), por favor diríjase al personal designado en la estación de control.\nGracias",
    PPE_DOCK_SAFETY_COMPLIANCE:
      "Al seleccionar SÍ, usted acepta cumplir con todas las leyes aplicables y con nuestras políticas. Se prohíbe el uso, la modificación o la distribución no autorizados. No nos hacemos responsables de ningún daño. Para más información, consulte nuestra Política de Privacidad y los términos completos.\n El incumplimiento de los requisitos de seguridad en el muelle o de EPP puede resultar en multas. Si necesita asistencia con la seguridad en el muelle o tiene inquietudes relacionadas con el equipo de protección personal (EPP) por favor diríjase al personal designado en la estación de control.",
    REASON_FOR_ENTRY: "Motivo del ingreso",
    REEFER_FUEL_LEVEL: "Nivel de combustible del refrigerado",
    REEFER_ON: "Refrigerado Encendido / Apagado",
    SEAL_NUMBER: "Número de sello",
    SEARCH_CARRIER: "Buscar un transportista...",
    SELECT_FACILITY: "Seleccione la instalación...",
    SELECT_X: "Seleccione {{X}}",
    SIGNATURE: "Firma",
    TEMPERATURE_F: "Temperatura (Â°F)",
    TRACTOR_CARRIER_NAME: "Nombre del transportista del tractocamión",
    TRACTOR_NUMBER: "Número del tractocamión",
    TRAILER_CARRIER_NAME: "Nombre del transportista del remolque",
    TRAILER_MIDDLE: "Parte media",
    TRAILER_NOSE: "Frente",
    TRAILER_NUMBER: "Número de remolque",
    TRAILER_TAIL: "Parte trasera",
    TRAILER_TYPE: "Tipo de remolque",
    VALIDATION_PERIOD: "Período de validación",
  },
  QUESTION: {
    ACTUAL_TEMPERATURE_F: "Temperatura actual °F",
    APPOINTMENT_DETAILS: "Información de la cita",
    COMPANY_INFO: "Información de la empresa",
    CONFIRM_SEAL_AND_TRAILER_NUMBER:
      "Confirme que el sello esté intacto y que el número de remolque sea correcto",
    CONFIRM_TRAILER_CONDITION:
      "Confirme que el remolque esté libre de residuos, que los tándems estén en posición trasera y que el refrigerado esté funcionando.",
    DRIVER_NAME: "Ingrese el nombre del conductor",
    DRIVER_TYPE: "Tipo de conductor",
    ENTRY_PURPOSE: "Seleccione el propósito de ingreso",
    ENTRY_TYPE: "Seleccione su tipo de ingreso",
    EQUIPMENT_DETAILS: "Información del equipo",
    GENERIC: "Complete la información",
    LOAD_DETAILS: "Información de la carga",
    LOAD_TYPE: "Seleccione el tipo de carga",
    PERSONAL_INFO: "Información personal",
    PPE_DOCK_SAFETY: "EPP y seguridad en el andén",
    PPE_DOCK_SAFETY_COMPLIANCE:
      "Al continuar, usted acepta cumplir con todas las leyes aplicables y nuestras políticas. Se prohíbe el uso, la modificación o la distribución no autorizados. No somos responsables de los daños ocasionados por el uso de la aplicación. Para más información, consulte nuestra Política de Privacidad y los términos completos.",
    SET_TEMPERATURE_F: "Temperatura programada °F",
    SHIPPING_DETAILS: "Información del envío",
    VEHICLE_DETAILS: "Información del vehículo",
    VISIT_TYPE: "Elija su tipo de visita",
    WAIVER: "Exención",
  },
  STATUS: {
    ACTIVE: "Vigente",
    EXPIRED: "Vencida",
    EXPIRING_SOON: "Próxima a vencer",
  },
  SUCCESS_PAGE: {
    COMMAND: {
      DOWNLOAD: "Descargar",
      EMAIL: "Correo electrónico",
      HOME: "Inicio",
      MESSAGE: "Mensaje",
      START_OVER: "Reiniciar",
    },
    DRIVER_CHECK_IN_SUCCESS: "Ingreso iniciado con éxito",
    DRIVER_CHECK_OUT_SUCCESS: "Salida iniciada con éxito",
    GENERATING_QR_CODE: "¡Se está generando el código QR!",
    PLEASE_CHECK_DASHBOARD: "Revise el panel AVAC para conocer el estado",
    PLEASE_SCAN_CODE: "Escanee su código QR en el quiosco.",
    PLEASE_WAIT: "Espere un momento...",
    QR_CODE_GENERATED: "¡Código QR generado!",
  },
  SUGGESTION: {
    PO_NUMBER_OR_LOAD_ID: "Complete el campo con el número de OC o con el ID de carga",
  },
  TITLE: {
    CARRIER: "Transportista",
    CATEGORY: "Categoría",
    COMPANY_NAME: "Nombre de la empresa",
    EMAIL_ADDRESS: "Dirección de correo electrónico",
    ENTRY_SUB_TYPE: "Subtipo de ingreso",
    ENTRY_TYPE: "Tipo de ingreso",
    FIRST_NAME: "Nombre",
    LAST_NAME: "Apellido",
    PHONE_NUMBER: "Número de teléfono",
    REASON_FOR_ENTRY: "Motivo del ingreso",
    REFERENCE_NUMBER: "Número de referencia",
    SEAL_NUMBER: "Número de sello",
    SIGNATURE: "Firma",
    TEMPERATURE: "Temperatura",
    TRAILER_NUMBER: "Número de remolque",
    VALIDATION_PERIOD: "Período de validación",
  },
  TOOLTIP: {
    ADD: "Agregar",
    ARROW: "flecha",
    COMPANY_LOGO: "Logotipo de la empresa",
    DOWNLOAD: "descargar",
    LOGO: "Logotipo",
    MENU: "menú",
    SORT_ASC: "orden ascendente",
    SORT_DESC: "orden descendente",
  },
  VALIDATION: {
    EMAIL_ADDRESS: "Ingrese un correo electrónico válido",
    ERROR: {
      BOL_VALIDATION_FAILED: "Error al validar el número de referencia",
      FUEL_VALIDATION_FAILED: "Error al obtener las estadísticas del refrigerado",
      INVALID_BOOKING_NUMBER: "Número de reserva no válido",
      INVALID_FACILITY: "Instalación no válida",
      INVALID_LOAD_ID: "ID de carga no válido",
      LOAD_ID_VALIDATION_FAILED: "No se pudo validar el número de ID de carga",
      PO_VALIDATION_FAILED:
        "OC no válida. Inténtelo nuevamente o acuda con el encargado de recepción de carga.",
      TRAILER_VALIDATION_FAILED: "Error al validar la información del remolque",
    },
    FLOAT: "Ingrese únicamente números válidos (p. ej. 123 o 123.45)",
    NUMERIC: "Ingrese solo números",
    PERSON_NAME: "Debe contener solo letras y espacios",
    PHONE_NUMBER: "Formato de número de teléfono incorrecto",
    PO_NUMBER_OR_LOAD_ID: "Ingrese el número de OC o el ID de carga",
    TEMPERATURE_FROM_N20F_TO_P100F: "La temperatura debe estar entre -20Â°F y 100Â°F",
    VALIDATING_REFERENCE_NUMBER: "Verificando el número de referencia",
    VALIDATING_TRAILER_DETAILS: "Verificando la información del remolque",
  },
} as const;
